import { useMemo, useState } from 'react'

export function useCounter(initialValue) {
  const [count, setCount] = useState(initialValue || 0)

  const callbacks = useMemo(
    () => ({
      increment: () => setCount(x => x + 1),
      decrement: () => setCount(x => x - 1),
      reset: () => setCount(initialValue || 0)
    }),
    [initialValue]
  )

  return [
    count,
    {
      set: setCount,
      ...callbacks
    }
  ]
}
